import React from 'react'
import Skeleton from '@softwaredev_cegeka/stix-core/dist/components/Skeleton'
import styles from './menuLoader.module.scss'

export default function MenuLoader({ count = 3 }) {
    return Array(count)
        .fill()
        .map((_, i) => {
            return (
                <div className={styles.wrapper} key={i}>
                    <Skeleton
                        width={150}
                        height="1rem"
                        className={styles.skeleton}
                    />
                </div>
            )
        })
}
